/**
 * Constants used throughout the application
 */

export const MAX_GUESSES = 6;

export const ATTRIBUTE_LABELS = {
  game: 'GAME',
  element: 'ELEMENT',
  speed: 'SPEED',
  health: 'HEALTH',
  armor: 'ARMOR',
  gender: 'GENDER',
  color: 'COLOR'
};

export const ELEMENT_RELATIONSHIPS = {
  'Undead': ['Earth', 'Life'],
  'Earth': ['Tech', 'Water'],
  'Tech': ['Magic', 'Fire'],
  'Magic': ['Undead', 'Air'],
  'Air': ['Life', 'Earth'],
  'Life': ['Water', 'Tech'],
  'Water': ['Fire', 'Magic'],
  'Fire': ['Air', 'Undead']
};
